// extracted by mini-css-extract-plugin
export default {"label":"Tag_label__4fD5m"};